export const ManagementAccountId = 181570489212;

export const orgHierarchyMock = [
  {
    Arn: "arn:aws:organizations::855075416228:root/o-4lvue3i8mc/r-s8sx",
    Children: [
      {
        Arn: "arn:aws:organizations::855075416228:ou/o-4lvue3i8mc/ou-s8sx-zdmcf47o",
        Children: [
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/023653793110",
            Day2Onboarded: false,
            Email: "cct-account1@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "023653793110",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2023-04-24 10:28:13.163000+00:00",
            Name: "CloudCoreTech-Account1",
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/608663481108",
            Day2Onboarded: false,
            Email: "cct-account2@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "987654321098",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2023-04-24 14:01:03.710000+00:00",
            Name: "Acme_aws_org_audit",
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/061902162789",
            Day2Onboarded: false,
            Email: "cct-account3@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "456789012345",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2023-04-24 13:07:05.131000+00:00",
            Name: "CloudCoreTech-Account3",
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
        ],
        Id: "ou-s8sx-zdmcf47o",
        Name: "CloudCoreTech",
        Type: "ORGANIZATION_UNIT",
      },
      {
        Arn: "arn:aws:organizations::855075416228:ou/o-4lvue3i8mc/ou-s8sx-gxg4a73y",
        Children: [
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/494531732514",
            Day2Onboarded: false,
            Email: "dng-account1@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "562783538012",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2022-12-05 11:04:26.817000+00:00",
            Name: "Acme_aws_org_logging",
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/045091622349",
            Day2Onboarded: true,
            Email: "dng-account2@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "045091622349",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2022-12-05 11:23:28.375000+00:00",
            Name: "DataNexusGroup-Account2",
            OnboardingDetails: {
              CreatedOn: "2023-06-07 05:31:09",
              CustomerAccountId: "1f1923ba-f95a-4819-b044-95630a1ad054",
              Status: "PENDING",
            },
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
        ],
        Id: "ou-s8sx-gxg4a73y",
        Name: "DataNexusGroup",
        Type: "ORGANIZATION_UNIT",
      },
      {
        Arn: "arn:aws:organizations::855075416228:ou/o-4lvue3i8mc/ou-s8sx-nf7u0dkw",
        Children: [
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/310236733906",
            Day2Onboarded: true,
            Email: "ico-account1@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "123456789012",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2023-04-24 16:19:49.276000+00:00",
            Name: "InnovateCloudOps-Account1",
            OnboardingDetails: {
              CreatedOn: "2023-06-07 05:38:00",
              CustomerAccountId: "28ff4afb-0ef9-4a41-b8f2-f5ddcedb810e",
              Status: "CONNECTED",
            },
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/175853853950",
            Day2Onboarded: true,
            Email: "ico-account2@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "175853853950",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2023-04-24 16:18:43.778000+00:00",
            Name: "InnovateCloudOps-Account2",
            OnboardingDetails: {
              CreatedOn: "2023-06-07 05:25:43",
              CustomerAccountId: "9b309f56-685a-458a-803a-a9414e6f2905",
              Status: "PENDING",
            },
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/422038605703",
            Day2Onboarded: false,
            Email: "ico-account3@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "422038605703",
            JoinedMethod: "INVITED",
            JoinedTimestamp: "2021-08-17 09:33:13.588000+00:00",
            Name: "InnovateCloudOps-Account3",
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/497742316979",
            Day2Onboarded: true,
            Email: "ico-account4@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "678901234567",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2023-04-24 18:53:44.790000+00:00",
            Name: "InnovateCloudOps-Account4",
            OnboardingDetails: {
              CreatedOn: "2023-06-07 05:48:28",
              CustomerAccountId: "329fc03b-e4ff-4caf-b618-348e0b3bda37",
              Status: "CONNECTED",
            },
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/497166044454",
            Day2Onboarded: false,
            Email: "ico-account5@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "497166044454",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2023-04-25 18:18:24.459000+00:00",
            Name: "InnovateCloudOps-Account5",
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/910630083164",
            Day2Onboarded: false,
            Email: "ico-account6@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "821383721923",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2023-04-20 19:18:35.807000+00:00",
            Name: "InnovateCloudOps-Account6",
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/451756267643",
            Day2Onboarded: false,
            Email: "ico-account7@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "567890123456",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2023-04-26 17:17:05.042000+00:00",
            Name: "InnovateCloudOps-Account7",
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
          {
            Arn: "arn:aws:organizations::855075416228:ou/o-4lvue3i8mc/ou-s8sx-bgge2jxo",
            Children: [
              {
                Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/200273373262",
                Day2Onboarded: true,
                Email: "icop-account1@example.com",
                IS_MANAGEMENT_ACCOUNT: false,
                Id: "200273373262",
                JoinedMethod: "CREATED",
                JoinedTimestamp: "2023-04-28 06:59:46.300000+00:00",
                Name: "InnovateCloudOpsPlus-Account1",
                OnboardingDetails: {
                  CreatedOn: "2023-06-06 11:00:46",
                  CustomerAccountId: "b8f7ed00-6f25-45a1-9175-c4da2cd74b65",
                  Status: "PENDING",
                },
                Status: "ACTIVE",
                Type: "ACCOUNT",
              },
              {
                Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/632977991184",
                Day2Onboarded: true,
                Email: "icop-account2@example.com",
                IS_MANAGEMENT_ACCOUNT: false,
                Id: "632977991184",
                JoinedMethod: "CREATED",
                JoinedTimestamp: "2023-04-28 06:58:13.021000+00:00",
                Name: "InnovateCloudOpsPlus-Account2",
                OnboardingDetails: {
                  CreatedOn: "2023-06-06 12:31:14",
                  CustomerAccountId: "9c090e18-354c-49d2-b2c9-a415e58f2aa6",
                  Status: "CONNECTED",
                },
                Status: "ACTIVE",
                Type: "ACCOUNT",
              },
              {
                Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/068106707784",
                Day2Onboarded: false,
                Email: "icop-account3@example.com",
                IS_MANAGEMENT_ACCOUNT: false,
                Id: "068106707784",
                JoinedMethod: "CREATED",
                JoinedTimestamp: "2023-04-28 10:01:02.071000+00:00",
                Name: "InnovateCloudOpsPlus-Account3",
                Status: "ACTIVE",
                Type: "ACCOUNT",
              },
            ],
            Id: "ou-s8sx-bgge2jxo",
            Name: "InnovateCloudOpsPlus",
            Type: "ORGANIZATION_UNIT",
          },
        ],
        Id: "ou-s8sx-nf7u0dkw",
        Name: "InnovateCloudOps",
        Type: "ORGANIZATION_UNIT",
      },
      {
        Arn: "arn:aws:organizations::855075416228:ou/o-4lvue3i8mc/ou-s8sx-7u2xej7f",
        Children: [
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/051908244533",
            Day2Onboarded: true,
            Email: "dsynergy-account1@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "051908244533",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2023-05-25 10:01:08.916000+00:00",
            Name: "DevOpsSynergy-Account1",
            OnboardingDetails: {
              CreatedOn: "2023-06-07 05:34:30",
              CustomerAccountId: "cec88d59-3c4d-415e-88b8-08462f9d78da",
              Status: "CONNECTED",
            },
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
        ],
        Id: "ou-s8sx-7u2xej7f",
        Name: "DevOpsSynergy",
        Type: "ORGANIZATION_UNIT",
      },
      {
        Arn: "arn:aws:organizations::855075416228:ou/o-4lvue3i8mc/ou-s8sx-o7lscjdp",
        Children: [
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/242415865739",
            Day2Onboarded: false,
            Email: "agilecs-account1@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "242415865739",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2018-05-02 00:49:38.323000+00:00",
            Name: "AgileCloudSolutions-Account1",
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/653168383433",
            Day2Onboarded: false,
            Email: "agilecs-account2@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "653168383433",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2020-09-14 10:50:14.316000+00:00",
            Name: "AgileCloudSolutions-Account2",
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/638792416726",
            Day2Onboarded: false,
            Email: "agilecs-account3@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "638792416726",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2018-05-02 05:26:14.375000+00:00",
            Name: "AgileCloudSolutions-Account3",
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/252310902838",
            Day2Onboarded: false,
            Email: "agilecs-account4@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "252310902838",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2018-05-02 00:50:26.016000+00:00",
            Name: "AgileCloudSolutions-Account4",
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/908268824556",
            Day2Onboarded: false,
            Email: "agilecs-account5@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "908268824556",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2020-09-14 14:44:00.581000+00:00",
            Name: "AgileCloudSolutions-Account5",
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/002181633924",
            Day2Onboarded: false,
            Email: "agilecs-account6@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "213729832792",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2020-08-07 23:33:08.454000+00:00",
            Name: "AgileCloudSolutions-Account6",
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/427363035968",
            Day2Onboarded: false,
            Email: "agilecs-account7@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "427363035968",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2020-09-14 13:19:51.287000+00:00",
            Name: "AgileCloudSolutions-Account7",
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/669045753101",
            Day2Onboarded: false,
            Email: "agilecs-account8@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "901234567890",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2020-09-14 10:49:26.176000+00:00",
            Name: "AgileCloudSolutions-Account8",
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
        ],
        Id: "ou-s8sx-o7lscjdp",
        Name: "AgileCloudSolutions",
        Type: "ORGANIZATION_UNIT",
      },
      {
        Arn: "arn:aws:organizations::855075416228:ou/o-4lvue3i8mc/ou-s8sx-ve85n0e8",
        Children: [
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/434429996591",
            Day2Onboarded: false,
            Email: "tvh-account1@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "434429996591",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2021-10-26 05:07:36.736000+00:00",
            Name: "TechVentureHub-Account1",
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
          {
            Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/341308857630",
            Day2Onboarded: true,
            Email: "tvh-account2@example.com",
            IS_MANAGEMENT_ACCOUNT: false,
            Id: "341308857630",
            JoinedMethod: "CREATED",
            JoinedTimestamp: "2021-10-26 05:07:20.311000+00:00",
            Name: "TechVentureHub-Account2",
            OnboardingDetails: {
              CreatedOn: "2023-06-06 16:15:37",
              CustomerAccountId: "a56f193f-a1e2-4f5b-9b06-6b943ecd8d8f",
              Status: "CONNECTED",
            },
            Status: "ACTIVE",
            Type: "ACCOUNT",
          },
        ],
        Id: "ou-s8sx-ve85n0e8",
        Name: "TechVentureHub",
        Type: "ORGANIZATION_UNIT",
      },
      {
        Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/855075416228",
        Day2Onboarded: true,
        Email: "cloudtechsolutions@example.com",
        IS_MANAGEMENT_ACCOUNT: true,
        Id: "181570489212",
        JoinedMethod: "INVITED",
        JoinedTimestamp: "2018-05-02 00:47:51.142000+00:00",
        Name: "Acme Inc Master AWS Account",
        OnboardingDetails: {
          CreatedOn: "2023-05-09 14:37:21",
          CustomerAccountId: "ad9981cd-cc93-45c0-963b-c1598f9d16c4",
          Status: "CONNECTED",
        },
        Status: "ACTIVE",
        Type: "ACCOUNT",
      },
      {
        Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/576838678373",
        Day2Onboarded: false,
        Email: "datainnovators@example.com",
        IS_MANAGEMENT_ACCOUNT: false,
        Id: "576838678373",
        JoinedMethod: "CREATED",
        JoinedTimestamp: "2021-03-31 18:47:37.711000+00:00",
        Name: "DataInnovators",
        Status: "ACTIVE",
        Type: "ACCOUNT",
      },
      {
        Arn: "arn:aws:organizations::855075416228:account/o-4lvue3i8mc/679310863504",
        Day2Onboarded: true,
        Email: "techopsconsulting@example.com",
        IS_MANAGEMENT_ACCOUNT: false,
        Id: "679310863504",
        JoinedMethod: "CREATED",
        JoinedTimestamp: "2023-05-25 11:44:10.120000+00:00",
        Name: "TechOpsConsulting",
        OnboardingDetails: {
          CreatedOn: "2023-06-06 12:34:33",
          CustomerAccountId: "08165c73-caeb-4931-9140-d807649eabb3",
          Status: "CONNECTED",
        },
        Status: "ACTIVE",
        Type: "ACCOUNT",
      },
    ],
    Id: "r-s8sx",
    Name: "Root",
    PolicyTypes: [
      {
        Status: "ENABLED",
        Type: "TAG_POLICY",
      },
      {
        Status: "ENABLED",
        Type: "SERVICE_CONTROL_POLICY",
      },
    ],
    Type: "ROOT",
  },
];
